import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/shared/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { DashboardFacade } from './dashboard.facade';
import { MyFamilyGroupFacade } from './dashboard-my-family-group/my-family-group.facade';




@NgModule({
  providers: [DashboardFacade, MyFamilyGroupFacade],
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    MaterialModule,
    SharedModule
  ],

})
export class DashboardModule { }
